import "./Subcategory.css";

import { Breadcrumb, message, Table, type TableColumnsType } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader, TableMenuDropdown } from "../../_lib/_components";
import {
  deleteSubcategory,
  getSubcategories,
  type SubCategoryType,
  useAppSelector,
} from "../../_lib/_store";

export const SubcategoryPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, subCategories } = useAppSelector(
    (state) => state.subCategory,
  );
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getSubcategories(messageApi);
  };

  const columns: TableColumnsType<SubCategoryType> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Package Id",
      dataIndex: "package",
      key: "package",
      render: (_, obj) => <p>{obj?.package?.name}</p>,
    },
    {
      title: "Category Id",
      dataIndex: "category",
      key: "category",
      render: (_, obj) => <p>{obj?.category?.name}</p>,
    },
    {
      title: "Parent Id",
      dataIndex: "parentId",
      key: "parentId",
      render: (_, obj) => <p>{obj?.parentId}</p>,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: SubCategoryType) => {
    switch (key) {
      case "show":
        navigate(`/subcategory/show`, { state: { subcategory: obj } });
        break;
      case "edit":
        navigate(`/subcategory/edit`, { state: { subcategory: obj } });
        break;
      case "delete":
        deleteSubcategory(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="category">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: "Sub Category",
            },
          ]}
        />
        <SectionHeader
          dataLength={subCategories.length}
          createRoute="subcategory"
        />
        <Table
          sticky
          dataSource={subCategories}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1000 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
